module.exports = __webpack_public_path__ + "media/images/next-042a09a47fe60ac4800d093926579bbc.png";